import { useMemo, useState } from 'react'
import { api, ROUTES } from './api'
import { useAsync, Pager, ErrorState, Loading, Empty, PageHead, dateFmt } from './ui'

const PER = 12

export default function Customers() {
  const { data, loading, error, reload } = useAsync(() => api.get(ROUTES.adminUsers))
  const [q, setQ] = useState('')
  const [page, setPage] = useState(1)
  const users = data || []
  const filtered = useMemo(() => users.filter((u) => `${u.name} ${u.email} ${u.phone ?? ''}`.toLowerCase().includes(q.toLowerCase())), [users, q])

  if (error) return <ErrorState error={error} endpoint={`GET ${ROUTES.adminUsers}`} onRetry={reload} />

  return (
    <>
      <PageHead title="Customers" sub={`${users.length} registered accounts`} />
      <div className="toolbar"><input className="input" placeholder="Search by name, email or phone" value={q} onChange={(e) => { setQ(e.target.value); setPage(1) }} /></div>
      {loading ? <Loading /> : filtered.length === 0 ? <Empty title="No customers found" /> : (
        <div className="table-wrap">
          <table className="table">
            <thead><tr><th>Name</th><th>Email</th><th>Phone</th><th>Joined</th><th>Orders</th></tr></thead>
            <tbody>
              {filtered.slice((page - 1) * PER, page * PER).map((u) => (
                <tr key={u.id}>
                  <td>{u.name}</td><td>{u.email}</td><td>{u.phone || '-'}</td>
                  <td>{dateFmt(u.createdAt ?? u.created_at)}</td>
                  <td>{u.orders ?? u.orderCount ?? '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <Pager page={page} total={filtered.length} per={PER} onPage={setPage} />
    </>
  )
}
